import type { Fill } from '@nktkas/hyperliquid'
import { useQuery } from '@tanstack/react-query'

import { getInfoClient } from '@/lib/hooks/useHyperClient'
import HyperSDK from '@/lib/utils/hyper.sdk.utils'
import type { UserFills } from '@/lib/utils/hyper/types'
import { HexString } from '../config/wagmi'

const infoClient = getInfoClient()

export interface UseUserFillsProps {
  user: HexString
}

/**
 * Hook to fetch user trading fills/history from Hyperliquid
 * @param user - User's wallet address
 * @returns Query result with user fills data
 */
export function useUserFills(user: HexString) {
  return useQuery<UserFills>({
    queryKey: ['userFills', user],
    queryFn: async () => {
      const infoClient = await HyperSDK.info()
      return infoClient.getUserFills(user)
    },
    enabled: !!user,
    staleTime: 60 * 1000, // 1 minutes
  })
}

export function useHLUserFills(user: HexString) {
  return useQuery<Fill[]>({
    queryKey: ['userFills', user],
    queryFn: async () => {
      const result = await infoClient.userFills({ user })
      return result
    },
    enabled: !!user,
    staleTime: 60 * 1000, // 1 minutes
  })
}
